import React from 'react'
import { rankWith, scopeEndsWith } from '@jsonforms/core'

import ElementWrapper from 'designer/component/display/layout/control/ElementWrapper'
import DragElementWrapper from 'designer/component/system/layout/control/DragElementWrapper'

import CustomVideoWebcam from 'designer/component/element/VideoWebcam'

export const VideoWebcamSystem = (props) => (
  <DragElementWrapper {...props}>
    <CustomVideoWebcam {...props} />
  </DragElementWrapper>
)

export const VideoWebcamDisplay = (props) => (
  <ElementWrapper {...props}>
    <CustomVideoWebcam {...props} />
  </ElementWrapper>
)

export const videoWebcamTester = rankWith(1000, scopeEndsWith('videoWebcam'))
